import React from 'react';
import DebtClockLayout from './components/DebtClock/DebtClockLayout';
import DebtClockCard from './components/DebtClock/DebtClockCard';
import useFetchDebtData from './hooks/fetchDebtData';
import { resolveProvince } from './debtClockUtils';
import './debt-clock-embed.css';

const MESSAGES = {
  en: {
    loading: 'Loading debt clock...',
    unavailable: 'Debt clock unavailable.',
    missing: 'Debt clock data missing.',
  },
  fr: {
    loading: 'Chargement de l’horloge de la dette…',
    unavailable: 'Horloge de la dette indisponible.',
    missing: 'Données de l’horloge de la dette manquantes.',
  },
};

const resolveMessages = (language) => {
  const code = (language || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';
  return MESSAGES[code];
};

const DebtClockEmbed = ({ province, language, variant }) => {
  const lang = language || 'en';
  const copy = resolveMessages(lang);
  const { debtData, isLoading, error } = useFetchDebtData();
  const isCard = String(variant || 'default').toLowerCase() === 'card';

  if (isLoading) {
    return <div className="ctf-debt-clock-loading">{copy.loading}</div>;
  }
  if (error) {
    return <div className="ctf-debt-clock-error">{copy.unavailable}</div>;
  }
  if (!debtData || Object.keys(debtData).length === 0) {
    return <div className="ctf-debt-clock-error">{copy.missing}</div>;
  }

  const resolvedProvince = resolveProvince(province, debtData);
  if (!debtData[resolvedProvince]) {
    return <div className="ctf-debt-clock-error">{copy.unavailable}</div>;
  }

  if (isCard) {
    return (
      <DebtClockCard
        province={resolvedProvince}
        language={lang}
        debt_data={debtData}
      />
    );
  }

  return (
    <DebtClockLayout
      province={resolvedProvince}
      language={lang}
      debt_data={debtData}
    />
  );
};

export default DebtClockEmbed;
